import { useTranslation } from "react-i18next";
const Mailbox = () => {
  const { t } = useTranslation();
  return <div>{t("GENERAL.PROCESSING")}</div>;
};

export default Mailbox;
